module.exports = __webpack_public_path__ + "static/media/20201114_120954_514_IMG_9934.a6474e11.jpg";